<template>
  <section class="n-container search-page">
    <!-- 搜索框  :input="searchParams.keywords" -->
    <section class="search-wrap" ref="search">
      <n-search
        ref="nsearch"
        v-model="keyword"
        @by-keyword="handleSearchKeyword"
        @by-image="handleSearchImage"
        @by-error="handleSearchError"
      ></n-search>
      <div class="hot-keyword">
        <span>热门搜索:</span>
        <span
          v-for="item in hotKeyword"
          :key="item"
          @click="handleHotKey(item)"
          >{{ item }}</span
        >
      </div>
    </section>
    <!-- 关键字 -->
    <section class="result-info__wrap" ref="result">
      <div class="result-text">
        共找到<strong>{{ searchParams.keywords }}</strong>
        <span>相关</span>
        <strong>{{ searchParams.total }}</strong
        >张图片
      </div>
      <div class="search-btn__wrap">
        <span>排序:</span>
        <el-select
          v-model="order"
          placeholder="请选择"
          @change="handleSelected"
        >
          <el-option
            v-for="item in orderOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <span>版式:</span>
        <el-select v-model="type" placeholder="请选择" @change="handleSelected">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </section>
    <!-- 搜索结果 -->
    <section class="result-image__wrap">
      <section class="result" v-if="result.length > 0">
        <waterfall
          :line="line"
          :line-gap="300"
          :min-line-gap="250"
          :max-line-gap="400"
          :watch="result"
          @reflowed="reflowed"
          ref="waterfall"
        >
          <!-- each component is wrapped by a waterfall slot -->
          <waterfall-slot
            v-for="(item, index) in result"
            :width="item.width"
            :height="item.height"
            :order="index"
            :key="index"
            move-class="item-move"
          >
            <div class="item" :index="item.src" @click="handleClickImage(item)">
              <div class="item-btn__wrap">
                <el-tooltip effect="light" content="下载" placement="top">
                  <n-icon
                    icon="iconxiazai-hui"
                    @click="handleShowDownload(item)"
                    :fill="item.downloaded"
                    color="eee"
                  ></n-icon>
                </el-tooltip>
                <el-tooltip effect="light" content="收藏" placement="top">
                  <n-icon
                    icon="iconshoucang-hong"
                    @click="handleFav(item)"
                    :fill="item.faved"
                    color="eee"
                  ></n-icon>
                </el-tooltip>
              </div>
              <el-image :src="item.src + '?x-oss-process=image/resize,h_400,m_lfit'" lazy></el-image>
              <!-- <img :src="item.src" alt="" v-if="index < 2" />
              <img v-lazy="item.src" alt="" v-else /> -->
            </div>
          </waterfall-slot>
        </waterfall>
        <div class="page-wrap">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="searchParams.total"
            :page-size="searchParams.page_size"
            :current-page.sync="searchParams.page"
            @current-change="handleCurrentChange"
            @prev-click="handlePrevClick"
            @next-click="handleNextClick"
          >
          </el-pagination>
        </div>
      </section>
      <section class="no-result" v-else>
        <p>没有查询到任何关于{{ searchParams.keywords }}的结果</p>
        <p>您可以简化或缩短关键词再进行搜索</p>
      </section>
    </section>
    <!-- 收藏夹 -->
    <fav-modal
      :show.sync="showFav"
      :favs.sync="favs"
      @ok="handleConfirmFav"
    ></fav-modal>
    <!-- 下载弹窗 -->
    <base-modal :show.sync="down.showDownload" @ok="handleDownload">
      <p class="down-content__wrap">
        您的账户目前可下载{{ down.showTotal }}张
      </p>
    </base-modal>
    <!-- 购买弹窗 -->
    <base-modal :show.sync="down.showBuy">
      <p class="down-content__wrap">您的账户目前可下载0张</p>
      <template v-slot:footer>
        <div class="buy-btn__wrap">
          <n-button size="medium" @click="handleBuy">购买套餐</n-button>
          <n-button type="default" size="medium" @click="handleCancel"
            >取消</n-button
          >
        </div>
      </template>
    </base-modal>
    <n-loading :loading="loading"></n-loading>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Waterfall from "vue-waterfall/lib/waterfall";
import WaterfallSlot from "vue-waterfall/lib/waterfall-slot";
import { ItemFactory } from "@/item-factory.js";
export default {
  components: {
    waterfall: Waterfall,
    "waterfall-slot": WaterfallSlot,
  },
  data() {
    return {
      //下载
      down: {
        //选中的图片id
        imageId: 0,
        //套餐数量
        showTotal: 0,
        //下载弹窗
        showDownload: false,
        //购买弹窗
        showBuy: false
      },
      //是否登录
      isLogin: false,
      //搜索loading
      loading: false,
      //收藏夹弹窗
      showFav: false,
      //指定图片的收藏click
      favImageId: false,
      //版式筛选
      type: "0",
      //版式筛选选项
      typeOptions: [
        { value: "0", label: "全部" },
        { value: "1", label: "横图" },
        { value: "2", label: "竖图" },
        { value: "3", label: "方图" },
      ],
      //排序类型
      order: "_score",
      //排序类型选项
      orderOptions: [
        { value: "_score", label: "系统推荐" },
        { value: "created_at", label: "最新发布" },
      ],
      check: true,
      //查询参数
      searchParams: {
        total: 0, //搜索结果总数
        keywords: "", //关键字
        page: 1, //当前页码
        page_size: 50, //分页大小
        sort: "", //排序
        scale: "", //版式筛选
      },
      //查询结果
      result: [],
      //热门关键字
      hotKeyword: ["人物", "风景", "美食", "建筑", "汽车", "电器"],
      line: "h",
      isBusy: false,
      //收藏夹
      favs: [],
      //收藏夹错误信息
      err: {
        code: "4000",
        msg: "文件夹名称重复啊",
      },
    };
  },
  computed: {
    ...mapGetters(["getKeyword", "getSearchImage"]),
    keyword: {
      set(val) {
        this.setKeyword(val);
      },
      get() {
        return this.getKeyword;
      },
    },
    searchImage: {
      set(val) {
        this.setSearchImage(val);
      },
      get() {
        return this.getSearchImage;
      },
    },
  },
  watch: {
    check() {},
  },
  mounted() {
    window.scrollTo(0, 10);
  },
  created() {
    if (this.searchImage) {
      this.handleSearchImage(this.searchImage);
      this.searchImage = null;
    } else {
      this.search();
    }
  },
  methods: {
    ...mapMutations({
      setKeyword: "keyword",
      setSearchImage: "searchImage"
    }),
    //文字搜索
    search(page) {
      var _self = this;
      if (page) {
        this.searchParams.page = page;
      }
      this.searchParams.keywords = this.keyword;
      this.searchParams.sort = this.order;
      this.searchParams.scale = this.type;
      this.$axios.api.search(this.searchParams, null, function (res) {
        if (res.code == 1) {
          _self.searchRes(res);
        }
      });
    },
    //搜索结果渲染
    searchRes(res) {
      var data = res.data;
      var _self = this;
      this.searchParams.total = data.total;
      this.isLogin = data.is_login;
      this.favs = data.favorites;
      this.result = [];
      data.list.filter(function (item) {
        _self.result.push({
          id: item._source.info.id,
          src: item._source.info.thumb_url,
          width: item._source.info.width,
          height: item._source.info.height,
          faved: item._source.isfav ? true : false,
          downloaded: false,
        });
      });
      window.scrollTo(0, 20);
      setTimeout(()=>{
        window.scrollTo(0, 0);
      },1000)
    },
    //搜索框错误提示
    handleSearchError(msg) {
      this.$message.error(msg);
    },
    //搜索框文字搜索
    handleSearchKeyword(keyword) {
      // this.searchParams.keywords = keyword;
      this.result = [];
      this.search(1); //搜索重置当前页数
    },
    //搜索框图片搜索
    handleSearchImage(image) {
      var _self = this;
      var formData = new FormData();
      this.result = [];
      formData.append("file", image.file);
      formData.append("keywords", 'image_search');
      var config = {headers: {'Content-Type': 'multipart/form-data'} };
      this.$axios.api.search(formData, config, function (res) {
        _self.$refs.nsearch.hideUpload(true);
        if (res.code == 1) {
          _self.searchRes(res);
        } else {
          _self.$message.error(res.msg);
        }
      });
    },
    //热门关键字
    handleHotKey(val) {
      this.keyword = val;
      this.search(1);
    },
    //下拉选择排序、图片排版类型
    handleSelected() {
      this.search(1);
    },
    //下载弹窗
    handleShowDownload(item) {
      this.handleClickImage(item);
      return;
      this.down.showTotal = this.$store.state.userInfo.combo_num;
      this.down.imageId = item.id;
      if (this.down.showTotal > 0) {
        this.down.showDownload = true;
      } else {
        this.down.showBuy = true;
      }
    },
    //确认下载
    handleDownload() {
      console.log(this.down.imageId)
    },
    //点击图片
    handleClickImage(item) {
      let routeData = this.$router.resolve({
        name: "image",
        query: { id: item.id },
      });
      window.open(routeData.href, "_blank");
    },
    //收藏click
    handleFav(item) {
      this.favImageId = item.id;
      if (this.isLogin) {
        if (item.faved) {
          this.$confirm("是否取消收藏?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            var _self = this;
            this.$axios.api.favoritesCancel({thumb_id: item.id}, function (res) {
              if (res.code == 1) {
                _self.$message.success("取消收藏成功！");
                item.faved = false;
              } else {
                _self.$message.error("取消收藏失败！");
              }
            });
          }).catch(() => {

          });
        } else {
          this.showFav = true;
        }
      } else {
        passportLogin.login();
      }
    },
    //收藏
    handleConfirmFav(item) {
      if (!item) {
        this.$message.error("请选择收藏夹");
        return;
      }
      var _self = this;
      this.$axios.api.favoritesJoin({favorite_id: item.id, thumb_id: this.favImageId}, function (res) {
        if (res.code == 1) {
          _self.$message.success("添加收藏成功！");
          _self.showFav = false;
          for (var i= 0; i < _self.result.length; i++) {
            if (_self.result[i].id == _self.favImageId) {
              _self.result[i].faved = true;
            }
          }
        } else {
          _self.$message.error("添加收藏失败！");
        }
      });
    },
    //购买
    handleBuy() {
      this.$router.push({ path: "/prepay" });
      this.showBuy = false;
    },
    handleCancel() {
      this.showBuy = false;
    },
    //添加mock图片数据
    addItems(id) {
      console.log(id);
      if (!this.isBusy) {
        this.isBusy = true;
        this.result.splice(0, this.result.length, ...ItemFactory.get(id));
        this.isBusy = false;
        window.scrollTo(0, 10);
      }
    },
    reflowed() {
      this.isBusy = false;
    },
    //下一页
    handleNextClick(page) {
      // console.log(page);
    },
    //上一页
    handlePrevClick(page) {
      // console.log(page);
    },
    //页码改变
    handleCurrentChange(page) {
      this.search(page);
      // this.addItems(val);
    },
  },
};
</script>

<style lang="scss">
.search-page {
  width:100%;
  .search-wrap {
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 120px;
    max-width: 643px;
    padding: 0 20px;
    margin-bottom: 53px;
    .hot-keyword {
      padding: 12px 26px;
      font-size: 14px;
      color: #333333;
      > span {
        margin-right: 11px;
        cursor: pointer;
        &:hover {
          color: #f77e5e;
        }
      }
    }
  }
  .down-content__wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 30px;
    font-size: 18px;
    font-weight: 400;
    color: #333333;
  }
  .buy-btn__wrap {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    .n-button {
      margin-right: 30px;
      margin-left: 30px;
    }
  }
}

.result-info__wrap {
  width:100%;
  background: #eeeeee;
  margin: 0 auto;
  margin-bottom: 32px;
  padding: 0 28px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #333333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .result-text {
    > strong {
      font-size: 24px;
      font-weight: bold;
      color: #ec7a5d;
      margin: 0 16px;
    }
  }
}
.search-btn__wrap {
  font-size: 16px;
  color: #ddd;
  > span {
    color: #333;
    margin-right: 10px;
  }
  .el-input {
    width: 130px;
  }
  .el-input__suffix {
    right: 27px;
  }
  .el-select .el-input.is-focus .el-input__inner {
    border: none;
  }
  .el-select .el-input__inner:focus {
    border: none;
  }
  .el-select .el-input.is-focus .el-input__inner {
    border: none;
  }
  .el-input__inner {
    background-color: #eeeeee;
    border: none;
  }
}
.download-tip {
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 50px 72px;
  font-size: 18px;
  color: #333333;
}
.result-image__wrap {
  width: 100%;
  // height: 1000px;
  > .no-result {
    margin: 0 auto;
    width: 914px;
    height: 650px;
    padding-top: 400px;
    text-align: center;
    border-radius: 5px;
    background: url("https://www.pai2345.com/static/web/manual-retouching/images/pic-8.png") no-repeat center 150px;
    margin-top: -40px;
    > p {
      font-size: 28px;
      color: #333333;
    }
    & p:nth-child(2) {
      font-size: 24px;
      margin-top: 20px;
      color: #666666;
    }
  }
  .item-move {
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    -webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
  }
  .item {
    position: absolute;
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    font-size: 1.2em;
    background:#f5f5f5;
  }
  .item {
    overflow: hidden;
    cursor: pointer;
    &:hover .item-btn__wrap {
      display: flex;
      bottom: 16px;
      right: 0px;
      opacity: 1;
    }
  }
  .item > img {
    width: 109%;
  }
  .item > span {
    position: absolute;
    top: 50%;
    left: 50%;
    color: #fff;
    font-size: 100px;
    transform: translate(-50%, -50%);
    color: #9b9b9b;
  }
  .item-btn__wrap {
    width: 100%;
    height: 40px;
    position: absolute;
    right: -140px;
    bottom: 16px;
    z-index: 2;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    opacity: 0;
    transition: all 0.4s ease-in-out;
    > .n-icon {
      margin-right: 22px;
    }
  }
  .page-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 60px 0;
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: $primaryColor;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: $primaryColor;
      color: #fff;
    }
  }
}
</style>
